import PropTypes from "prop-types";
import Avatar from "@mui/material/Avatar";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import { fileUrl } from "../../../components/Utils";

export default function PwaProfileAvatar({ photoId }) {
  const size = (theme) => theme.spacing(6);

  return (
    <Avatar
      src={photoId ? fileUrl(photoId) : undefined}
      alt=""
      sx={{ width: size, height: size, bgcolor: "transparent" }}
    >
      <AccountCircleIcon
        aria-hidden="true"
        sx={{ width: size, height: size, fontSize: size, color: "primary.interactive" }}
      />
    </Avatar>
  );
}

PwaProfileAvatar.propTypes = {
  photoId: PropTypes.string,
};
